<template>
  <div class="discount-and-utm-page scrollable">

    <!-- page header with breadcrumbs -->
    <div class="page-header">
      <h1>Discount Coupons</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>Discount Coupons</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- page tabs content -->
    <div class="card-base card-shadow p-30">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="Generate coupon" name="generate">
          <GenerateCouponForm />
        </el-tab-pane>

        <el-tab-pane label="Coupons list" name="history">
          <CouponsHistoryTable />
        </el-tab-pane>

        <el-tab-pane label="Create discount" name="discounts">
          <DiscountsListTable />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import GenerateCouponForm from './GenerateCouponForm'
  import CouponsHistoryTable from './CouponsHistoryTable'
  import CouponEditDialog from './CouponEditDialog'
  import DiscountsListTable from './DiscountsListTable'

  export default {
    name: 'DiscountCouponsPage',
    components: {
      GenerateCouponForm,
      CouponsHistoryTable,
      CouponEditDialog,
      DiscountsListTable
    },
    data() {
      return {
        activeTab: 'generate'
      }
    },
    beforeCreate() {
      this.$store.dispatch('discountCoupons/getPlanGroups')
      this.$store.dispatch('discountCoupons/getDiscounts')
    }
  }
</script>
